import Price from '~/libs/Price/Price';

export default function calculateProductUDTDPackagePrice(price: Price | null, packageSize: number): Price {
	return new Price(String(Number(price?.value || 0) / packageSize), price?.currency || '');
}
